export const WITHDRAWAL_REASON_WITHDRAWAL_REVERSAL = "withdrawal-reversal";
export const WITHDRAWAL_REASON_CANCELLED_WITHDRAWAL = "cancelled-withdrawal";
export const WITHDRAWAL_REASON_PAYMENT_REVERSAL = "payment-reversal";
export const WITHDRAWAL_REASON_PAYMENT_CANCELLED = "cancelled-payment";
export const PAYMENT_CANCELLATION_REASON = "cancellation";
export const FEE_REASON = "fee";
export const DEBIT_REASON = "debit";
export const PENDING_PAYMENT_REASON = "pending-payment";

//
// Journal-payment
// pending-payment
// fee
// cancelled-payment
// payment-reversal

// Trade-journal
// settlement
// fee
// margin
// margin-release
